import { Grid, Typography } from "@mui/material";
import FormSection from "../../../../../../common/components/functional/formSection/FormSection";
import { FormTitleGrid } from "../../../../styles";
import { ReactElement } from "react";

type Props = {
  title?: string;
  rows: { title: string; component: JSX.Element }[];
  infoTooltip?: ReactElement;
  titleWidth?: number;
  contentWidth?: number;
};

export const FormRow = ({
  title,
  component,
  titleWidth = 3,
  contentWidth = 9,
}: {
  title: string;
  component: JSX.Element;
  titleWidth?: number;
  contentWidth?: number;
}) => {
  return (
    <>
      <FormTitleGrid container item xs={titleWidth}>
        <Typography variant="secondary">{title}</Typography>
      </FormTitleGrid>
      <Grid item xs={contentWidth} display="flex">
        {component}
      </Grid>
    </>
  );
};

export const FormSectionComponent = ({
  title,
  rows,
  infoTooltip,
  titleWidth,
  contentWidth,
}: Props) => {
  return (
    <FormSection title={title} infoTooltip={infoTooltip}>
      {rows.map((r, i) => (
        <FormRow
          key={`${title}_${i}`}
          title={r.title}
          component={r.component}
          titleWidth={titleWidth}
          contentWidth={contentWidth}
        />
      ))}
    </FormSection>
  );
};
